import type { Plugin } from "@capacitor/core/types/definitions";

export interface LpapiPluginPlugin extends Plugin {
  getPairedPrinters(): Promise<any>;
  connectPrinter(options: PrinterAddress): Promise<any>;
  disconnectPrinter(): Promise<any>;
  printText(options: PrinterOptions): Promise<any>;
  printText1DBarcode(options: PrinterOptions): Promise<any>;
  drawText(options: TextOptions): Promise<any>;
  drawText1DBarcode(options: TextOptions): Promise<any>;
  getPrinterState(): Promise<any>;
  drawCircle(options: ShapeOptions): Promise<any>;
  drawRect(options: ShapeOptions): Promise<any>;
  drawLine(options: ShapeOptions): Promise<any>;
  startJob(option: LabelOptions): Promise<any>;
  abortJob(): Promise<any>;
  commitJob(): Promise<any>;
}

export interface PrinterAddress {
  name: string;
  address: string;
}

export interface PrinterOptions extends LabelOptions, TextOptions
{

}

export interface LabelOptions {
  labelWidth: number;
  labelHeight: number;
}

export interface TextOptions {
  text: string;
  x: number;
  y: number;
  width: number;
  height: number;
  textHeight: number;
}

export interface ShapeOptions {
  v: number;
  v1: number;
  v2: number;
  v3: number;
  v4: number;
}
